import Entity from "@/services/westore/entities/entity";

export class MarketPlaces extends Entity {
  static uri = "/integrations";

  static getAll() {
    return super.getAll(MarketPlaces.uri);
  }
  static removeIntegration(id) {
    return super.delete(`${MarketPlaces.uri}/${id}`);
  }
}
